import { render } from "./formChievement.vue?vue&type=template&id=522b92d4&scoped=true"
import script from "./formChievement.vue?vue&type=script&lang=js"
export * from "./formChievement.vue?vue&type=script&lang=js"

import "./formChievement.vue?vue&type=style&index=0&id=522b92d4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522b92d4"]])

export default __exports__